
var AWS = require('aws-sdk/global');
var AWSCognito = require('aws-sdk/clients/cognitoidentity');
var AmazonCognitoIdentity = require('amazon-cognito-identity-js'); // required to use cognito sdk in web env
var S3 = require('aws-sdk/clients/s3');
var SNS = require('aws-sdk/clients/sns');

var router = require('./router').router;
var awsConstants = require('./constants').awsConstants;
var swal = require('bootstrap-sweetalert');
swal.setDefaults({ animation: false });

AWS.config.region = awsConstants.region;
var awsCognito = new AWSCognito();

awsCognito.config.region = 'us-west-2';
var region = 'us-west-2';
var s3Ready = new Event('s3Ready');
var snsReady = new Event('snsReady');
var userPool = new AmazonCognitoIdentity.CognitoUserPool(awsConstants.getPoolData());

// Change password page and signin page
function signin(username, password, newPassword) {
    var authenticationData = {
        Username: username,
        Password: password
    };
    var userPool = new AmazonCognitoIdentity.CognitoUserPool(awsConstants.getPoolData());
    var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
    var userData = {
        Username: username,
        Pool: userPool
    };

    window.cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

    return new Promise(function (resolve, reject) {
        window.cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (result) {
                resolve(null);
            },
            onFailure: function (error) {
                reject(error);
            },
            newPasswordRequired: function (userAttributes, requiredAttributes) {
                if (window.location.hash.indexOf('change-password') !== -1) {
                    window.cognitoUser.completeNewPasswordChallenge(newPassword, null, this);
                } else {
                    // Redirect to change password page for entering new password
                    localStorage.setItem('username', username);
                    router.navigate('/change-password?resetrequired');
                }
            }
        });
    });
}

// Checks if session is valid and redirects accordingly
var authHandler = {
    init: function (dispatchS3Ready) {
        var self = this;
        this.isSigninPage = window.location.hash.indexOf('signin') !== -1;
        window.cognitoUser = userPool.getCurrentUser();

        var initPromise;
        if (window.cognitoUser !== null) {
            // Check if user is logged in to User Pool
            if (window.session) {
                initPromise = Promise.resolve(null);
            } else {
                initPromise = this.getSession()
                    .then(function (session) {
                        window.session = session;
                    });
            }
            return initPromise.then(function () {
                // Add the User's Id Token for Federated Identities
                var credentialsParams = {
                    IdentityPoolId: awsConstants.identityPoolId
                };
                credentialsParams.Logins = {};
                credentialsParams.Logins[awsConstants.cognitoLoginObjectKey] = window.session.getIdToken().getJwtToken();
                awsCognito.config.credentials = new AWS.CognitoIdentityCredentials(credentialsParams);
                var awsConfigCredentials = awsCognito.config.credentials;
                if (window.session.isValid()) {
                    // redirects to dashboard page based on valid session
                    // no need for further initialization if redirect is taking place
                    if (self.isSigninPage ||
                        window.location.pathname === '/' && window.location.hash === '' ||
                        window.location.pathname.indexOf('index.html') !== -1) {
                        router.navigate('/dashboard');
                        return true;
                    }
                    self.setResourceCredentials(awsConfigCredentials, dispatchS3Ready);
                    return true;
                } else {
                    return self.refreshToken(awsConfigCredentials, dispatchS3Ready)
                        .then(function () {
                            console.log('token refresh');
                            return true;
                        });
                }
            });
        } else {
            self.navigateToSignIn();
            return Promise.reject('authexpired');
        }
    },
    getSession: function () {
        return new Promise(function (resolve, reject) {
            window.cognitoUser.getSession(function (error, session) {
                if (error) {
                    reject(error);
                }
                resolve(session);
            });
        });
    },
    setResourceCredentials: function (credentials, dispatchS3Ready) {
        window.s3 = new S3({ credentials: credentials, region: region });
        window.sns = new SNS({ credentials: credentials, region: region });
        if (dispatchS3Ready) {
            document.dispatchEvent(s3Ready);
        }
        document.dispatchEvent(snsReady);
    },
    refreshTokenIfNeeded: function() {
        if (window.session.isValid()) {
            return Promise.resolve(null);
        } else {
            return authHandler.init();
        }
    },
    refreshToken: function (credentials, dispatchS3Ready) {
        var self = this;
        return new Promise(function (resolve, reject) {
            // Refresh to login in to Federated Identities pool
            credentials.refresh(function (error) {
                if (error) {
                    reject(error);
                } else {
                    self.setResourceCredentials(credentials, dispatchS3Ready);
                    resolve(null);
                }
            });
        });
    },
    navigateToSignIn: function () {
        if (window.location.pathname.indexOf('index.html') === -1 &&
            window.location.hash.indexOf('signin') === -1 &&
            !(window.location.pathname === '/' && window.location.hash === '') &&
            window.location.hash.indexOf('change-password') === -1) {
            swal('Please login session expired', 'error');
        }

        if (!this.isSigninPage && window.location.hash.indexOf('change-password') === -1) {
            router.navigate('/signin');
        }
    }
};

var logoutHandlerController = {
    init: function () {
        this.logoutButtonEl = document.querySelector('#logout-button');
        logoutHandlerView.init();
    },
    logout: function () {
        if (window.cognitoUser !== null) {
            window.cognitoUser.getSession(function (error, session) {
                if (error) {
                    swal('Session Error', error, 'error');
                }
                // Need to clear federated identity cash else will error on next login if a different user is on the device
                var credentialsParams = {
                    IdentityPoolId: awsConstants.identityPoolId
                };
                credentialsParams.Logins = {};
                credentialsParams.Logins[awsConstants.cognitoLoginObjectKey] = session.getIdToken().getJwtToken();
                awsCognito.config.credentials = new AWS.CognitoIdentityCredentials(credentialsParams);
                awsCognito.credentials = new AWS.CognitoIdentityCredentials(credentialsParams);
                awsCognito.credentials.clearCachedId();
                // Then sign out of userpool
                window.cognitoUser.signOut();
                // Clear temp storage
                try {
                    localStorage.clear();
                } catch (e) {
                    console.log(e);
                }
                router.navigate('/signin?logout=successful');
            });
        }
    }
};

var logoutHandlerView = {
    init: function () {
        this.logoutButtonEl = document.querySelector('#logout-button');
        this.logoutButtonEl.addEventListener('click', function () {
            logoutHandlerController.logout();
        });
    }
};

module.exports = {
    authHandler: authHandler,
    logoutHandlerController: logoutHandlerController,
    signin: signin
};
